module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_c('br', {
    staticClass: "calibre2"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("“Observe constantly that all things take place by change, "), _c('br'), _vm._v("and accustom thyself to consider that"), _c('br'), _vm._v("the nature of the universe loves nothing so much as"), _c('br'), _vm._v("to change the things which are,"), _c('br'), _vm._v("and make new things like them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph2"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("—Marcus Aurelius")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63b45faa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Epigraph.vue
// module id = 75
// module chunks = 0